import {shuffle} from "./shuffle";
import {spread} from "./spread";

export class Random {
    constructor(private seed: number) {
    }

    next() {
        let rnd = this.seed += 0x6D2B79F5;
        rnd = Math.imul(rnd ^ rnd >>> 15, rnd | 1);
        rnd ^= rnd + Math.imul(rnd ^ rnd >>> 7, rnd | 61);

        return ((rnd ^ rnd >>> 14) >>> 0) / 4294967296;
    }

    nextInt(min: number, max?: number) {
        return randomInt(min, max, this.next.bind(this));
    }

    equiprobable<T>(...variants: T[]): T {
        return equiprobable(variants, this.nextInt.bind(this));
    }

    shuffle<T>(variants: T[]): T[] {
        return shuffle(variants, this.next.bind(this));
    }

    spread(medians: number | number[], dispersion: number = 0.5) {
        return spread(medians, dispersion, this.next.bind(this));
    }
}

export function xmur3(key: string | number) {
    const str = "" + key;
    let h = 1;

    for(let i = 0, h = 1779033703 ^ str.length; i < str.length; i++) {
        h = Math.imul(h ^ str.charCodeAt(i), 3432918353);
    }

    h = h << 13 | h >>> 19;

    h = Math.imul(h ^ h >>> 16, 2246822507);
    h = Math.imul(h ^ h >>> 13, 3266489909);

    return (h ^= h >>> 16) >>> 0;
}

export function equiprobable<T>(variants: T[], randomFn: (max: number) => number = randomInt): T {
    return variants[randomFn(variants.length)];
}

export function random(min: number, max?: number, randomFn: () => number = Math.random) {
    if (max === undefined) {
        max = min;
        min = 0;
    }

    return randomFn() * (max - min) + min;
}

export function randomInt(min: number, max?: number, randomFn: () => number = Math.random) {
    return Math.floor(random(min, max, randomFn));
}